export default __webpack_public_path__ + "static/media/clock.d706a807.png";